<template>
    <v-card class="mx-auto  !border-0 !shadow-none " color="black" dark>
        <!-- <v-icon color="#f6c44dd6" class=" absolute top-5 left-5 z-20">mdi-circle-slice-8</v-icon> -->
        <!-- <v-tooltip right :color="colorAsRoute">
            <template v-slot:activator="{ on, attrs }">
                <v-icon :color="colorAsRoute" @click="changeLayout" class=" !absolute top-5 left-5 z-20" v-bind="attrs"
                    v-on="on">mdi-circle-slice-8</v-icon>
            </template>
            <span class="">Switch to Classic View</span>
        </v-tooltip> -->
        <v-navigation-drawer touchless
            :class="`!border-0  !max-h-screen scrollbar-hide ${routeLink}_border_color ${isMobile ? 'nav_border-hide' : ''} md:!w-[380px]  sm:!w-[300px]  ${!navState ? '!w-0' : '!w-96'}`"
            permanent color="black" dark>
            <v-avatar width="100%" height="100%" tile class=" !sticky top-0 z-10 bg-black sm:!flex !hidden">
                <v-img class="md:!max-w-[180px] !max-w-[130px]" :src="require('@/assets/img/Logo/logo.gif')" />
            </v-avatar>
            <div class="sm:pt-8 pt-5 sm:px-6 px-4  h-full">

                <v-card :color="`${routeLink}_color`"
                    :class="`p-[1px]  ${routeLink + `_box-shadow`}  !rounded-[30px] mb-4`">
                    <div class="bg-black p-7 !rounded-[30px]">
                        <div class="flex align-items-center">
                            <v-avatar size="74" rounded="circle" color="gradient_color">
                                <v-img position="top center" class="!border-2 ma-0" :class="`${routeLink}-border`"
                                    max-width="70px" height="70px" :src="loggedInUser.image"></v-img>
                            </v-avatar>
                            <div class="ml-2">
                                <h3 class="font-Inter font-medium mb-1 text-white text-base capitalize">
                                    {{ loggedInUser.name }}
                                </h3>
                                <v-chip pill small :color="`${routeLink}_color`"
                                    class="text-black uppercase font-Inter font-medium !text-xs">Premium</v-chip>
                            </div>
                        </div>
                        <v-btn @click="navCloseOnClick" class="!mt-5 !w-full !text-black capitalize !font-Inter !font-medium !text-sm"
                            :to="{ name: 'MyProfile' }" rounded :color="`${routeLink}_color`">View Profile</v-btn>
                    </div>

                </v-card>


                <v-list rounded>
                    <v-list-item @click="navCloseOnClick" v-for="([icon, text, width, link, link_param], i) in items"
                    v-motion :initial="{ opacity: 0, y: 100 }" :enter="{
                        opacity: 1, y: 0, transition: {
                          duration: 400,
                          type: 'keyframes',
                          ease: 'backInOut',
                          delay: `${i}00`,
                        },
                      }"
                        :key="i" link :to="{ name: link, params: { type: routeLink, setting: link_param } }"
                        :color="colorAsRoute">
                        <v-list-item-icon class="!mr-5">
                            <!-- <v-img :src="require(`@/assets/img/nav-icons/premium/${icon}.png`)"></v-img> -->
                            <Icon :color="colorAsRoute" :icon="icon" :height="width" />
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title class="!capitalize !font-Inter !font-medium !text-base !text-white">{{
                                text
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item link loading="true" :color="colorAsRoute" @click.prevent="logOutUser" v-motion :initial="{ opacity: 0, y: 100 }" :enter="{
                        opacity: 1, y: 0, transition: {
                          duration: 400,
                          type: 'keyframes',
                          ease: 'backInOut',
                          delay: `500`,
                        },
                      }">
                        <v-list-item-icon class="!mr-5">
                            <!-- <v-img :src="require(`@/assets/img/nav-icons/premium/${icon}.png`)"></v-img> -->
                            <Icon :color="colorAsRoute" icon="fe:logout" height="30" />
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="!capitalize !font-Inter !font-medium !text-base !text-white">Log
                                Out</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-list rounded class="sm:!block !hidden">
                    <h3 :class="`${routeLink + `_fortext`} font-Inter font-medium text-xl`">Frequently Chats </h3>
                    <comet-chat-user-list :friendsOnly="true" :navDrawer="true" class="nav_user_list" key="drawerList" />
                </v-list>
                <v-list rounded>
                    <v-list-item :color="colorAsRoute" @click="changeLayout">
                        <v-list-item-icon class="!mr-3">
                            <Icon :color="colorAsRoute" icon="ep:switch" height="20" />
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title
                                class="!capitalize !font-Inter !font-medium !text-base !text-white">switch layout to
                                classic</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <spotify-player class="my-10" />
            </div>
            <div class="text-center my-5 capitalize text-white font-Inter font-medium text-xs">
                Copyrights &copy; 2022 MagnumXL. All Rights Reserved
            </div>
        </v-navigation-drawer>
    </v-card>
</template>
<script>
import SpotifyPlayer from './SpotifyPlayer.vue'
import { Icon } from '@iconify/vue2';
import { CometChatUI, CometChatUserList } from "../../chatApp/src";


export default {
    components: { SpotifyPlayer, Icon, CometChatUserList },
    data: () => ({
        items: [
            ['teenyicons:home-outline', 'home', 25, 'Profiles'],
            ['teenyicons:message-text-alt-outline', 'messages', 25, 'Chats'],
            ['material-symbols:notifications-active-outline-rounded', 'notifications', 30, 'Notifications'],
            ['fluent:settings-28-regular', 'settings', 30, 'SelectedSetting', 'ProfileSetting'],
        ],
        recent_messages: [
            ['girl1', 'Jessica Williams', 'online', '4'],
            ['girl2', 'Theressa Jorge', 'online', '2'],
            ['girl5', 'Jenny Wilson', 'offline', '7'],
            ['girl4', 'Darlene Robertson', 'online', '1'],
        ],
    }),
    computed: {
        
        navState() {
            return this.$store.getters.premiumNav;
        },
        getUnreadNotifications() {
            return this.$store.getters.unreadNotification
        },
        loggedInUser() {
            return this.$store.getters.StateUser.data
        },
        colorAsRoute() {
            if (this.routeLink == 'straight') {
                return '#a07a1d'
            }
            else if (this.routeLink == 'gay') {
                return '#88c3fa'
            }
            else if (this.routeLink == 'lesbian') {
                return '#9e2eec'
            }
        }
    },
    methods: {
        navCloseOnClick() {
            if (this.$store.getters.premiumNav) {
                this.$store.dispatch('premiumNav')
            } else {
                false
            }
        },
        changeLayout() {
            this.$store.dispatch('premiumLayout', false);
            if (this.$store.getters.premiumNav) {
                this.$store.dispatch('premiumNav')
            } else {
                false
            }
        },
        async logOutUser() {
            await this.$store.dispatch("LogOut");
            if (this.$store.getters.premiumNav) {
                this.$store.dispatch('premiumNav')
            } else {
                false
            }
        },
    },
    created() {
        this.$store.dispatch('messagesHandler')
    },

}
</script>
<style scoped>
.straight_color {
    /*background: linear-gradient(146deg, #dba83b, #d4b577 22%, #ae8935 30%, #a27c2b 70%, #d4b374 80%, #a87a2c);*/
    background: rgb(177, 145, 65);
    background: linear-gradient(180deg,
            rgb(97 69 0) 0%,
            rgba(202, 174, 112, 1) 53%,
            rgb(90 64 0 / 97%) 100%) !important;
}

.lesbian_color {
    background: rgb(126, 0, 157);
    background: linear-gradient(180deg,
            rgba(126, 0, 157, 0.9416141456582633) 2%,
            rgba(161, 51, 246, 1) 45%,
            rgba(157, 0, 176, 0.9668242296918768) 96%) !important;
}

.gay_color {
    background: rgb(0, 240, 255);
    background: linear-gradient(180deg,
            rgba(0, 240, 255, 1) 0%,
            rgba(0, 156, 255, 1) 100%) !important;
}

.btn_gradient_color {
    background: linear-gradient(180deg,
            rgb(147 105 0) 0%,
            rgba(202, 174, 112, 1) 53%,
            rgb(162 115 0 / 97%) 100%) !important;
}

.straight_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(180deg,
            rgb(136 97 0) 0%,
            rgb(255 223 153) 53%,
            rgb(130 93 0 / 97%) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.gay_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(180deg,
            rgba(0, 240, 255, 1) 55%,
            rgba(0, 156, 255, 1) 75%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.lesbian_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(180deg,
            rgba(126, 0, 157, 0.9416141456582633) 2%,
            rgba(161, 51, 246, 1) 45%,
            rgba(157, 0, 176, 0.9668242296918768) 96%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.online_badge:deep(.v-badge__badge) {
    width: 13px;
    height: 13px;
    border-radius: 50%;
}

.scrollbar-hide:deep(.v-navigation-drawer__content::-webkit-scrollbar) {
    display: none !important;
}


.straight_border_color:deep(.v-navigation-drawer__border) {
    background-color: #9a7006 !important;
    z-index: 101;
}

.lesbian_border_color:deep(.v-navigation-drawer__border) {
    background-color: #9e2eec !important;
    z-index: 101;
}

.gay_border_color:deep(.v-navigation-drawer__border) {
    background-color: #00a1c9 !important;
    z-index: 101;
}

.nav_border-hide:deep(.v-navigation-drawer__border) {
    display: none !important;
}

/* For IE, Edge and Firefox */
.scrollbar-hide {
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}

.straight_box-shadow {
    box-shadow: 0px 0px 20px 0 #f6c44dd6 !important;
}

.lesbian_box-shadow {
    box-shadow: 0px 0px 20px 0 #9e2eec !important;
}

.gay_box-shadow {
    box-shadow: 0px 0px 20px 0 #88c3fa !important;
}

.straight-border {
    border-color: #a07a1d;
}

.gay-border {
    border-color: #88c3fa;
}

.lesbian-border {
    border-color: #9e2eec;
}

.nav_user_list:deep(.search_input) {
    display: none !important;
}

.nav_user_list:deep(.v-list) {
    height: 100% !important;
}

.nav_user_list:deep(.v-list-item) {
    border-radius: 50px !important;
    padding: 10px 15px !important;
    margin: 0px !important;
    margin-bottom: 10px !important;
}

.nav_user_list:deep(.red_list.v-list-item--link:before) {
    border-radius: 50px !important;
}

.nav_user_list:deep(.v-list-item__content) {
    padding: 0 !important;
}
</style>